<template>
    <div class="row">
        <div class="col">
            <search></search>
            <result></result>
            <back-to-top></back-to-top>
        </div>
    </div>
</template>

<script>
    import Result from './states/Result'
    import Search from './states/Search'

    export default {
    
        components: {
            Search, Result
        }
    }
</script>
